import React from 'react'

import { CaretBottomIcon } from 'components/Utils/Icons'
import Button from 'components/base/Button'

import SelectRoleWrapper from './Wrapper'

type Role = {
  title: string
  description: string
}

type SelectRoleLayoutProps = {
  currentRole: string
  onSelectRole: (role: string) => void
  goToOrganizationUpgrade: ({ incentiveId }: { incentiveId: string }) => void
  roles: { [key: string]: Role }
  organizationIsFree: boolean
  placement?: string
  align?: string
  disabled?: boolean
  buttonProps?: object
  bodyProps?: object
}

const defaultBodyProps = {}
const defaultButtonProps = {}

export default function SelectRoleLayout({
  currentRole,
  roles,
  onSelectRole,
  buttonProps = defaultButtonProps,
  bodyProps = defaultBodyProps,
  organizationIsFree,
  goToOrganizationUpgrade,
  placement = 'bottom',
  align = 'start',
  disabled = false,
}: SelectRoleLayoutProps) {
  return (
    <SelectRoleWrapper
      onSelectRole={disabled ? () => {} : onSelectRole}
      placement={placement}
      align={align}
      bodyProps={bodyProps}
      roles={roles}
      organizationIsFree={organizationIsFree}
      goToOrganizationUpgrade={goToOrganizationUpgrade}
    >
      <Button.Tertiary
        slim
        className="text-align-left"
        {...buttonProps}
        disabled={disabled}
      >
        <div className="flexbox flexbox-align-center flexbox-justify-end width-full">
          {roles[currentRole].title}
          <CaretBottomIcon className="margin-left-smaller shade-30" size={16} />
        </div>
      </Button.Tertiary>
    </SelectRoleWrapper>
  )
}
